import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['row', 'template']
  static values = {
    categories: Array,
    initialRows: Array
  }

  connect() {
    this.rowId = 0
    this.boundOnAddClick = this.onAddClick.bind(this)

    const categories = this.hasCategoriesValue ? this.categoriesValue : []
    if (categories.length === 0) return

    if (this.hasInitialRowsValue && this.initialRowsValue.length > 0) {
      this.initialRowsValue.forEach(([category, amount]) => this.addRow(category, amount))
    }
    // Always ensure at least one row from the start
    if (!this.hasRowTarget) {
      this.addRow()
    }
    const addBtn = this.element.querySelector('[data-add-category-action]')
    if (addBtn) {
      addBtn.addEventListener('click', this.boundOnAddClick)
      this._addBtn = addBtn
    }
  }

  disconnect() {
    if (this._addBtn) {
      this._addBtn.removeEventListener('click', this.boundOnAddClick)
    }
  }

  addRow(category = '', amount = '') {
    const id = ++this.rowId
    const row = this.templateTarget.content.cloneNode(true)
    const rowEl = row.querySelector('[data-category-amounts-target="row"]')
    rowEl.dataset.rowId = id

    const categorySelect = row.querySelector('[data-category-select]')
    const amountInput = row.querySelector('[data-amount-input]')

    this.populateCategorySelect(categorySelect, category)
    amountInput.value = amount
    amountInput.placeholder = 'Amount'

    if (category) {
      amountInput.name = `category_amounts[${category}]`
    }

    const container = this.element.querySelector('[data-rows-container]')
    if (container) container.appendChild(row)
    this.refreshCategoryOptions()
  }

  onAddClick(event) {
    if (event) event.preventDefault()
    this.addRow()
  }

  reset() {
    const container = this.element.querySelector('[data-rows-container]')
    if (!container) return
    if (this.hasRowTarget) {
      this.rowTargets.forEach(row => row.remove())
    }
    this.addRow()
  }

  removeRow(event) {
    const row = event.currentTarget.closest('[data-category-amounts-target="row"]')
    if (row) {
      row.remove()
      this.refreshCategoryOptions()
    }
  }

  onCategoryChange() {
    this.refreshCategoryOptions()
    this.updateAmountInputNames()
  }

  populateCategorySelect(select, selectedCategory = '') {
    select.innerHTML = ''
    const blank = document.createElement('option')
    blank.value = ''
    blank.textContent = 'Select category...'
    select.appendChild(blank)

    const categories = this.hasCategoriesValue ? this.categoriesValue : []
    categories.forEach(cat => {
      const opt = document.createElement('option')
      opt.value = cat
      opt.textContent = cat
      if (cat === selectedCategory) opt.selected = true
      select.appendChild(opt)
    })
  }

  refreshCategoryOptions() {
    const selectedByOthers = this.getSelectedCategoriesByRow()
    this.rowTargets.forEach(row => {
      const select = row.querySelector('[data-category-select]')
      const currentSelection = select.value
      const options = select.querySelectorAll('option[value]')
      options.forEach(opt => {
        const val = opt.value
        if (!val) return
        const usedElsewhere = selectedByOthers.get(row)?.has(val)
        opt.disabled = usedElsewhere && val !== currentSelection
      })
    })
  }

  getSelectedCategoriesByRow() {
    const map = new Map()
    this.rowTargets.forEach(row => {
      const select = row.querySelector('[data-category-select]')
      const val = select?.value
      const others = this.rowTargets.filter(r => r !== row)
      const used = new Set(others.map(r => r.querySelector('[data-category-select]')?.value).filter(Boolean))
      map.set(row, used)
    })
    return map
  }

  updateAmountInputNames() {
    this.rowTargets.forEach(row => {
      const select = row.querySelector('[data-category-select]')
      const amountInput = row.querySelector('[data-amount-input]')
      const category = select?.value
      if (category) {
        amountInput.name = `category_amounts[${category}]`
      } else {
        amountInput.removeAttribute('name')
      }
    })
  }

}
